import { Block } from 'slate';
import { getLevel as getBulletLevel } from '../../../../../../../editJournal/slateUtilities/plugins/findBulletLevel';
import pasteParaInPara from './paste.paraInPara';
import pasteParaInListItem from './paste.paraInListItem';
import getCursorPosInBlock from '../getCursorPosInBlock';
import renderDict from '../renderDict';
import pasteListInPara from './paste.listInPara';
import insertTextNodes from './insertTextNodes';

export default (params) => {
  const {
    editor,
    index,
    copiedFragment,
    incomingBlock,
    incomingBlockKey,
    copiedParentBlock,
    copiedParentBlockType,
    focusBlockNodes,
    focusBlock,
    document,
    focusBlockKey,
  } = params;

  const focusParentBlock = document.getParent(focusBlockKey);
  const { type: focusParentType, key: focusParentBlockKey } = focusParentBlock;
  const incomingBlockParent = copiedFragment?.getParent(incomingBlockKey);
  const { type: incomingBlockParentType } = incomingBlockParent;

  // cursor position in between
  const { isInBetween } = getCursorPosInBlock({
    editor,
  });

  /**
   * Inserting multiple para line in empty para block
   */
  if (renderDict[focusParentType] === 'organization_role_editable_div') {
    // incoming parent is not list item
    if (incomingBlockParentType !== 'list_item') {
      // insert para in para
      pasteParaInPara({
        index,
        editor,
        copiedParentBlockType,
        copiedParentBlock,
        focusBlockKey,
        incomingBlock,
        incomingBlockParent,
        focusBlockNodes,
        focusBlock,
        copiedFragment,
        focusParentBlock,
        focusParentType,
        isInBetween,
      });
    } else if (incomingBlockParentType === 'list_item') {
      // paste list in para
      pasteListInPara(incomingBlock, editor);
    }
  } else if (focusParentType === 'list_item') {
    const pasteParaInListParams = {
      editor,
      focusBlock,
      focusParentBlock,
      incomingBlock,
      index,
    };

    // incoming block parent is not list item
    if (incomingBlockParent.type !== 'list_item') {
      pasteParaInListItem(pasteParaInListParams);
    } else if (index === 0) {
      // incoming block parent is list item
      pasteParaInListItem(pasteParaInListParams);
    } else {
      // find the depth of incoming list item
      const incomingListItemDepth = getBulletLevel({
        document: copiedFragment,
        currentBlock: incomingBlock,
      });

      // get focus block depth
      const focusBlockDepth = getBulletLevel({
        document,
        currentBlock: focusBlock,
      });

      // incoming list item depth is 1
      if (incomingListItemDepth - focusBlockDepth === 1) {
        // split node
        if (isInBetween) editor.splitBlock(2);

        // Create an unordered list
        const unorderedList = Block.create({
          type: 'unordered_list',
          nodes: [incomingBlockParent],
        });

        // insert the unordered list as child of focus block
        editor.insertNodeByKey(focusParentBlockKey, 1, unorderedList);

        if (isInBetween) editor.moveBackward(1);
        else editor.moveToEndOfNextBlock();
      } else if (incomingListItemDepth - focusBlockDepth === -1) {
        // split node
        editor.splitBlock(2);

        // current focus block & it's parent p-->li-->ul-->li-->ul
        const currFocusBlock = editor.value.focusBlock;
        const currFocusBlockParent = editor.value.document.getParent(
          currFocusBlock.key,
        );
        const currFocusBlockGrandParent = editor.value.document.getParent(
          currFocusBlockParent.key,
        );
        const currFocusBlockGreatGrandParent = editor.value.document.getParent(
          currFocusBlockGrandParent.key,
        );
        const currFocusBlockGreatGreatGrandParent =
          editor.value.document.getParent(currFocusBlockGreatGrandParent.key);

        // get the index of currFocusBlockGreatGrandParent in it's parent
        const currFocusBlockGreatGrandParentIndex =
          currFocusBlockGreatGreatGrandParent.nodes.findIndex(
            (node) => node.key === currFocusBlockGreatGrandParent.key,
          );

        // insert text nodes
        insertTextNodes(incomingBlock, editor);

        // insert the unordered list as child of focus block
        editor.moveNodeByKey(
          currFocusBlockParent.key,
          currFocusBlockGreatGreatGrandParent.key,
          currFocusBlockGreatGrandParentIndex + 1,
        );
      } else if (incomingListItemDepth - focusBlockDepth === 0) {
        // split node
        editor.splitBlock(2);

        // insert incoming text
        editor.insertText(incomingBlock.text);

        if (isInBetween) editor.splitBlock(2).moveBackward(1);
      }
    }
  }

  return true;
};
